import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';
import LabelControllers from './LabelControllers';
import LegendControllers from './LegendControllers';
import InteractivityController from './InteractivityController';

const Controllers = ({
  config = undefined,
  data = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  selectedColumn = undefined,
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
}) => (
  <>
    {[
      GeneralControllers,
      StyleControllers,
      LabelControllers,
      LegendControllers,
      InteractivityController,
    ].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedColumn={selectedColumn}
        isGlobalThemeActive={isGlobalThemeActive}
        isGlobalFontActive={isGlobalFontActive}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.shape({}),
  data: PropTypes.shape({}),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedColumn: PropTypes.shape({}),
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
};

export default Controllers;
